import { render, staticRenderFns } from "./KLoader.vue?vue&type=template&id=3e9e6c6e&scoped=true"
import script from "./KLoader.vue?vue&type=script&lang=js"
export * from "./KLoader.vue?vue&type=script&lang=js"
import style0 from "./KLoader.vue?vue&type=style&index=0&id=3e9e6c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9e6c6e",
  null
  
)

export default component.exports